//import 'regenerator-runtime/runtime';
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import axios from 'axios';


//React-Redux
import { connect } from "react-redux";
import { useDispatch, useSelector } from 'react-redux';
import { login } from "actions/auth";

import { TextField, Typography, Button } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

//Utilities Wrapper.
import { validateEmail, removeAllSpaces, digestMessage, isEmptyString, fetchVersion } from '../common_utils/utils';


//Images.
// import MavricLogo from "assets/img/mavric_logo.png";
// import BgBlueBackground from "assets/img/blue_background_title.png";
import BgBlue from "assets/img/blue_bg.png";
import BgBlueBackground from "assets/img/blue_background_title_1.png";
import BgBlackBackground from "assets/img/black_background.png";

import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import { useCookies } from 'react-cookie';
import { whiteColor } from "assets/jss/material-dashboard-react";

const { size } = typography;
const { text, transparent, primary, secondary, white } = colors;

//The login Page named as connect as wanted the description to differ to 
// understand the redux state and normal props sent to component. 
export default connect(({ isLoading }) => ({ isLoading }), { login })(props => {

  //Uses history to redirect page.
  let history = useHistory();

  //Get the state values

  const stateError = useSelector(state => state.error || null);
  const isError = useSelector(state => state.isError);
  const isAuthUser = useSelector(state => state.isAuthUser);
  const myRole = useSelector(state => state.role);
  console.log("myRole in Login.js : ", myRole);


  const UserId = useSelector(state => state.userid);
  // const CustomerId = useSelector(state => state.customerId);
  const RoleId = useSelector(state => state.roleId);
  const AccessToken = useSelector(state => state.accessToken);
  const isAccounting = (myRole === "accounting") ? true : false;
  const isSalesOperator = (myRole === "salesoperator") ? true : false;
  const isSalesAdmin = (myRole === "salesadmin") ? true : false;
  const isSupport = (myRole === "support") ? true : false;
  const isDealerAdmin = (myRole === "dealeradmin") ? true : false;
  const isDealerOperator = (myRole === "dealeroperator") ? true : false;
  const dispatch = useDispatch()


  const [emailAddr, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordFieldToUser, setShowPasswordFieldToUser] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  // const [stateError, setStateError] = useState(null);
  const [MsgSeverity, setMsgSeverity] = useState("error");
  const [cookie, setCookie] = useCookies(['token']);
  const [SSOData, setSSOData] = useState(null);
  const isSsoLogoutRequested = useSelector(state => state.isSsoLogoutRequested);
  const hostname = window.location.hostname;

  const queryParams = {
    // "customer_id": parseInt(CustomerId),
    "user_id": parseInt(UserId),
    "access_token": AccessToken,
    "role_id": parseInt(RoleId)
  };

  if (UserId) {
    axios.defaults.headers.common['data'] = JSON.stringify(queryParams);
  } else {
    axios.defaults.headers.common['data'] = null;
  }

  useEffect(() => {
  }, [emailAddr, password]);

  useEffect(() => {
    if (isError) {
      setProcessing(false);
    }
    if (isSsoLogoutRequested) {
      setProcessing(true);

      setTimeout(() => {
        setProcessing(false);
      }, 3000);
    }
  }, [ isError, isSsoLogoutRequested ]);

  const handleChange = (event) => {

    switch (event.target.name) {

      case 'emailAddr':
        let email = event.target.value;
        email = removeAllSpaces(email)
        setEmail(email);
        break;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (password === "") {
      setError("Password is required");
      return;
    }

    setProcessing(true);
    if (validateEmail(emailAddr)) {

      digestMessage(password).then(digestBuffer => {
        // console.log("hash pasword for", password, " : ", digestBuffer);
        let jsonPostMsg = {
          'email': emailAddr,
          'password': digestBuffer,
          // 'sso_data': {"auth_provider":"Mavric"}
          'sso_data': ""
        };
        props.login(jsonPostMsg);
      });

    } else {
      setProcessing(false);
      setError("Invalid Email Address.");
      return;
    }

  };

  const generateCodeVerifier = () => {
    const array = new Uint32Array(32);
    window.crypto.getRandomValues(array);
    return Array.from(array, dec => ('0' + dec.toString(16)).slice(-2)).join('');
  };

   const generateCodeChallenge = async (code_verifier) => {
    const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(code_verifier));
    let base64String = btoa(String.fromCharCode(...new Uint8Array(digest)));
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  };

  const generatePKCECodes = async () => {
    const code_verifier = generateCodeVerifier();
    const code_challenge = await generateCodeChallenge(code_verifier);
    return { code_verifier, code_challenge };
  };


  const handleNext = async () => {
    try {
      if (emailAddr === "") {
        setError("Email is required");
        return;
      };
      setProcessing(true);
      if (validateEmail(emailAddr)) {

        // Make a GET request for getting auth details
        const idpResponse = await axios.get(`/api/customers/admin/sso/idp/${emailAddr}`);

        // Extract the auth details from the idpResponse data
        const { auth_provider, client_id, tenant_id, issuer } = idpResponse.data.payload;
        // setSSOData(idpResponse.data.payload);

        console.log("idpResponse = ", idpResponse.data.payload);

        if (auth_provider == 'Mavric') {
          setShowPasswordFieldToUser(true);
          setError(null);
          setProcessing(false);
        } else if (auth_provider == 'Okta' || auth_provider == 'AzureAD') {

          let fetchSsoEndpointsResponse;

          if (auth_provider == 'Okta') {
            fetchSsoEndpointsResponse = await axios.get(`${issuer}/.well-known/openid-configuration`);
          } else {
            fetchSsoEndpointsResponse = await axios.get(`https://login.microsoftonline.com/${tenant_id}/v2.0/.well-known/openid-configuration`);
          }

          console.log("fetchSsoEndpointsResponse = ", fetchSsoEndpointsResponse);

          // Extract the required endpoints from the response data
          const { authorization_endpoint, userinfo_endpoint, introspection_endpoint, token_endpoint, revocation_endpoint, end_session_endpoint } = fetchSsoEndpointsResponse.data;

          let token_validation_endpoint, revoke_token_endpoint;

          if (auth_provider == 'Okta') {
            token_validation_endpoint = introspection_endpoint;
            revoke_token_endpoint = revocation_endpoint;
          } else {
            token_validation_endpoint = userinfo_endpoint;
            revoke_token_endpoint = "NULL";
          }

          // Generate new PKCE code verifier and code challenge
          const { code_verifier, code_challenge } = await generatePKCECodes();
          let logout_url = `${end_session_endpoint}?post_logout_redirect_uri=${(window.location.origin + '/login')}`;
          localStorage.setItem('ssoLogoutEndpoint', logout_url);
          // localStorage.setItem('ssoLogoutEndpoint', end_session_endpoint);
          localStorage.setItem('emailAddr', emailAddr);
          // localStorage.setItem('tanentId', tenant_id);
          localStorage.setItem('sso_data', JSON.stringify({
            'introspect_endpoint': token_validation_endpoint,
            'token_endpoint': token_endpoint,
            'revoke_token_endpoint': revoke_token_endpoint,
            'logout_endpoint': logout_url,
            // 'logout_endpoint': end_session_endpoint,
            'code_verifier': code_verifier
          }));

          // Define required parameters to construct the authorization URL
          const params = {
            client_id: encodeURIComponent(client_id),
            code_challenge: code_challenge,
            code_challenge_method: 'S256',
            redirect_uri: encodeURIComponent(`${window.location.origin}/ssoCallback`),
            response_type: 'code',
            state: 'active',
            scope: encodeURIComponent('openid offline_access')
          };

          // Redirect to authorization URL login page
          window.location.href = `${authorization_endpoint}?${Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join('&')}`;

          console.log("authorization url = ", `${authorization_endpoint}?${Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join('&')}`);

        } else {
          setProcessing(false);
          setError("User not found.");
        }
      } else {
        setProcessing(false);
        setError("Invalid email address.");
      }
    } catch (error) {
      setProcessing(false);
      setError("User not found.");
      console.error("Error occured while processing requests before backend login api call ", error);
    }
  };


  const handleCookie = () => {
    var now = new Date();
    var expirationTime = new Date(now.getTime() + 24 * 60 * 60 * 1000); //For 24 hours only

    // console.log("expirationDate : ", expirationTime);
    // setCookie('token', AccessToken, { 
    //   path: '/', 
    //   expires: expirationTime, 
    //   domain: ".wohlerinc.wmavric.com", 
    //   httpOnly: true, 
    //   secure: false,
    //   sameSite: 'none',
    //  });
    setCookie('token', AccessToken, { path: '/', expires: expirationTime, domain: hostname, httpOnly: true, secure: false });
  }

  const handleTogglePassword = () => setShowPassword(showPassword => !showPassword);

  //let hPaswd = digestMessage("Password");

  //console.log("Hashed Password : ",hPaswd);

  //Check whether already loggged in and isAuthorised.
  console.log("URL called in Login.js : ", window.location.href);

  // const fetchVersion = () => {
  //   getANTMediaVersion().then((response) => {
  //       const jsonData = response;
  //       // console.log("Data:", jsonData);

  //       jsonData.forEach((data) => {
  //         if (data.name === "mavric-ams") {
  //           const version = data.version != null ? data.version : " ";
  //           localStorage.setItem("ANTMediaVersion", version);
  //         }
  //       });
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching data for versions:', error);
  //     });
  // };

  if (isAuthUser) {
    console.log(" isAuthUser - Login.js --------------> isAuthUser : ", isAuthUser);
    // fetchVersion();
    // handleCookie();

    // return <Redirect to={{
    //   pathname: '/apps',
    //   state_name: { key: 'login' }
    // }} />;
    if (isAccounting) {
      return <Redirect to="/accounting/customers/list" />;
    } else if (isSupport) {
      return <Redirect to="/support/customers/list" />;
    } else if (isSalesAdmin) {
      return <Redirect to="/salesadmin/customers/list" />;
    } else if (isSalesOperator) {
      return <Redirect to="/salesoperator/customers/list" />;
    } else if (isDealerAdmin) {
      return <Redirect to="/dealeradmin/customers/list" />;
    } else if (isDealerOperator) {
      return <Redirect to="/dealeroperator/customers/list" />;
    } else {
      return <Redirect to="/login" />;
    }
    // if (isAdmin) {
    //   console.log("Redirecting to admin");
    //   return <Redirect to="/admin" />;
    // } else if (isManager) {
    //   console.log("Redirecting to Manager");
    //   return <Redirect to="/manager" />;
    // } else if (isOperator) {

    //   console.log("Redirecting to operator");
    //   return <Redirect to="/operator" />;
    // } else {
    //   console.log("role is not handled. : ", myRole);
    //   if (myRole != {}) {
    //     dispatch(apiError({ error: '"' + myRole + '" role is not handled.' }));
    //     //dispatch(clearStorage(true));
    //   }
    //   //setError(" role does not exists.");
    // }
  }

  console.log("stateError  ", stateError, " isError : ", isError, " error : ", error);

  return (

    <>
      <Grid container direction="row" alignItems="center" justifyContent="center" style={{ backgroundImage: `url(${BgBlue})`, minHeight: '100vh', padding: 0 }} >
        <Grid item>
          <Paper sx={{
            border: 0, backgroundColor: white.main, width: 900, minHeight: 570, display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
            "&.MuiPaper-root": {
              backgroundColor: `#FFF !important`,
              borderRadius: 2,
            },
            "@media (max-width: 1024px)": {
              // overflowX: "auto",
              width: '900px',
            },
            "@media (max-width: 800px)": {
              width: '440px',
            },
            "@media (max-width: 500px)": {
              width: '380px',
              paddingRight: '2vw',
            }
          }}>
            <div style={{ display: 'flex', justifyContent: 'center' }} >
              <form onSubmit={handleSubmit} style={{ marginLeft: '3vw', marginTop: '7.5vw' }}>
                <Grid container direction="column" justifyContent="center">
                  <Grid item>
                    <Typography variant="h3" color={secondary.main} noWrap sx={{ textTransform: 'capitalize', mb: 5, mt: 3 }}>
                      Log In
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container direction="column" justifyContent="center" alignItems="flex-start" rowSpacing={2}>

                  {showPasswordFieldToUser === false && (
                    <>
                      <Grid item>
                        <TextField
                          error={!validateEmail(emailAddr)}
                          required
                          autoFocus
                          id='emailAddr'
                          name='emailAddr'
                          label="Username"
                          placeholder="xyz@company.com"
                          value={emailAddr}
                          onChange={handleChange}
                          autoComplete="off"
                          margin="normal"
                          color="text"
                          sx={{
                            backgroundColor: primary.main,
                            width: 350,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                          }}
                          InputLabelProps={{ style: { color: secondary.main } }}
                          disabled={processing}
                          inputProps={{
                            onChange: (e) => setEmail(e.target.value),
                            onKeyDown: (e) => {
                              if (e.key === "Enter") {
                                handleNext();
                              }
                            }
                          }}
                        />
                      </Grid>

                      <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={handleNext}
                          disabled={processing}
                          sx={{
                            borderRadius: 8,
                            background: `linear-gradient(90deg,#007BCE,#004EA5)`,
                            marginTop: 0.5,
                            width: 350,
                            height: 50,
                            fontWeight: 'bold',
                            fontSize: size.md
                          }}
                        >
                          Next
                        </Button>

                        {processing && (
                          <CircularProgress color="secondary" size="1.8rem" sx={{ marginLeft: 2 }} />
                        )}
                      </Grid>
                    </>
                  )}

                  {showPasswordFieldToUser === true && (
                    <>
                      <Grid item>
                        <TextField
                          error={!isEmptyString(password)}
                          required
                          autoFocus
                          id="filled-password-input"
                          name="usrPassword"
                          label="Password"
                          type={showPassword ? "text" : "password"}
                          margin="normal"
                          sx={{
                            backgroundColor: primary.main,
                            width: 350,
                            boxShadow: '0px 4px 20px rgba(0,0,0,0.1)'
                          }}
                          InputLabelProps={{ style: { color: secondary.main } }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleTogglePassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityIcon color="secondary" /> : <VisibilityOffIcon color="secondary" />}
                                </IconButton>
                              </InputAdornment>
                            ),
                            onChange: (e) => setPassword(e.target.value),
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                handleSubmit(e);
                              }
                            }
                          }}
                        />
                      </Grid>

                      <Grid item>
                        <Button
                          type="submit"
                          color="secondary"
                          variant="contained"
                          sx={{
                            borderRadius: 8,
                            background: `linear-gradient(90deg,#007BCE,#004EA5)`,
                            marginTop: 2,
                            width: 350,
                            fontWeight: 'bold',
                            fontSize: size.md
                          }}
                        >
                          Login
                        </Button>
                      </Grid>
                    </>
                  )}

                  {(isError || error) && (
                    <Grid item>
                      <Alert elevation={6} variant="filled" severity={MsgSeverity} onClick={() => setError(null)} sx={{ py: 0 }}>
                        <Typography fontSize={size.xs} color="text" sx={{ fontWeight: 300 }}>
                          {(stateError != null) ?
                            ((localStorage.getItem("ssoLoginRequested") !== null) ?
                              "SSO login request failed. Please try again." :
                              "Incorrect Username or Password. Please try again.") :
                            (error)}
                        </Typography>
                      </Alert>
                    </Grid>
                  )}
                </Grid>
              </form>
              <Grid container direction="column" justifyContent="center" alignItems="flex-start">
                <Grid item>
                  <Box
                    component="img"
                    sx={{
                      width: '100%',
                      height: 'auto',
                      maxWidth: 600,
                      marginLeft: "2%",
                      marginTop: "2%",
                      "@media (max-width: 800px)": {
                        display: 'none',
                      }
                    }}
                    alt="Wohler Logo"
                    src={BgBlueBackground}
                    justifyContent="center"
                  />
                </Grid>
              </Grid>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </>

  );

});